export default __webpack_public_path__ + "images/1X.27b6cba.png";